import { render, staticRenderFns } from "./InvoiceOverdueNoticeMailButton.vue?vue&type=template&id=037238a1&"
import script from "./InvoiceOverdueNoticeMailButton.vue?vue&type=script&lang=ts&"
export * from "./InvoiceOverdueNoticeMailButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports